import React from "react";
import { Box, Stack } from "@mui/material";

interface PageRendererProps {
  sections: React.ReactNode[];
  widthMode?: "full" | "constrained";
  sectionGap?: number | string;
}

/**
 * Generic page renderer that composes multiple section components with consistent layout.
 * Used by pages that organize multiple sections (e.g., CareTeam page with AssignedClinicians, CareTeam, Providers).
 *
 * @param sections - Array of section components to render in order (already keyed as React elements)
 * @param widthMode - Layout mode: "full" for full-width, "constrained" for max-width container (default: constrained)
 */
const PageRenderer: React.FC<PageRendererProps> = ({
  sections,
  widthMode = "constrained",
  sectionGap = "48px",
}) => {
  const content = <Stack gap={sectionGap}>{sections}</Stack>;

  if (widthMode === "full") {
    return content;
  }

  return <Box data-testid="constrained-section" sx={{ maxWidth: "1000px", mx: "auto" }}>{content}</Box>;
};

export default PageRenderer;
